var React = require('react');

function MailInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"email","key":0},"gmail"),React.createElement("path",{"d":"M32 6v20c0 1.135-0.865 2-2 2h-2v-18.151l-12 8.62-12-8.62v18.151h-2c-1.135 0-2-0.865-2-2v-20c0-0.568 0.214-1.068 0.573-1.422 0.359-0.365 0.859-0.578 1.427-0.578h0.667l13.333 9.667 13.333-9.667h0.667c0.568 0 1.068 0.214 1.427 0.578 0.359 0.354 0.573 0.854 0.573 1.422z","key":1})]);
}

MailInline.defaultProps = {"version":"1.1","width":"20","height":"20","viewBox":"0 0 32 32"};

module.exports = MailInline;

MailInline.default = MailInline;
